<div
  class="bg-black w-full h-16"
  [ssDirectus]="{
    collection: 'mobileCTA',
    item: mobileCTAData.id,
    fields: ['actionButton'],
  }"
>
  <div class="flex w-full h-full justify-center items-center">
    <ss-building-block-button-link
      class="block w-36 h-10"
      [buttonLink]="mobileCTAData.actionButton"
    >
    </ss-building-block-button-link>
  </div>
</div>
